import React, { useState } from 'react'
import "./SignUp.css"
import { useDispatch } from 'react-redux'
import {Usersignup} from "../../features/User/UserAction"
import { useNavigate } from 'react-router-dom'


export default function SignUp({ setSignIn }) {
    const [success, setSuccess] = useState("true")
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [FormData, setFormData] = useState({
        name: "",
        email: "",
        contact: "",
        password: "",
        confirmpassword:""
    })
    const handleChange = (e) => { 
        setFormData({
            ...FormData, [e.target.name]: e.target.value
        })  
    }
    const handleSubmit = (e) => { 
        e.preventDefault()
        console.log(FormData)
        if(FormData.password === FormData.confirmpassword){
            dispatch(Usersignup(FormData)).unwrap()
            .then((originalPromiseResult) => {
                navigate(-1)
            })
            .catch((rejectedValueOrSerializedError) => {
                setSuccess("email")
                alert("Email already exists")
                console.log(rejectedValueOrSerializedError)
            })
        }
        else {   
            setSuccess("password") 
            alert("Password not matched")
            console.log("Password not matched");        
        }
    }

  return (
      <div className='signUp'>
          <div className="signUpContent">
             <strong> <h1 className='signUpHeading' >Welcome to Bookworm Store</h1></strong>
             <div className='ContentList' >
                 <span> <i className="fa-solid fa-dollar-sign"></i> Sell Your Old Books</span>
                 <span><i className="fa-solid fa-rectangle-ad"></i> Post a free add to maximise the reach</span> 
                <span> <i className="fa-solid fa-comments-dollar"></i> Used Books available at afforadable prices</span> 
              </div>
          </div>
          <div  className="signUpForm">
              <form className='signUp-form' onSubmit={handleSubmit} >
                  <div className='signUp-form-comp'>
                        <label className='signUp-form-label'>Name</label>
                        <div>
                            <input className='signUp-form-input' name='name' onChange={handleChange} value={FormData.name} placeholder='Joe' type= "text" />
                        </div>
                  </div>
                  <div className='signUp-form-comp'>
                        <label className='signUp-form-label'>Contact Number</label>
                        <div>
                            <input name='contact' className='signUp-form-input' onChange={handleChange} value={FormData.contact} placeholder="1234567890" type= "tel" />
                        </div>
                    </div>
                    <div className='signUp-form-comp'>
                        <label className='signUp-form-label'>Email</label>
                        <div>
                          <input name='email' className='signUp-form-input' onChange={handleChange} value={FormData.email} placeholder='Email@gmail.com' type="email" />
                        </div>
                    </div>
                    <div className='signUp-form-comp'>
                        <label className='signUp-form-label'>Password</label>
                        <div>
                            <input onChange={handleChange} value={FormData.password} name='password'  className='signUp-form-input' placeholder='Enter Password' type= "password" />
                        </div> 
                    </div>
                    <div className='signUp-form-comp'>
                      <label className='signUp-form-label'>Confirm Password   </label>
                        <div>
                          <input name='confirmpassword' onChange={handleChange} value={FormData.confirmpassword} className='signUp-form-input' placeholder='Confirm Password' type="password" />
                        </div>
                  </div>
                 { 
                  success !== "true" && <div className='signUp-form-comp'>
                        <div className='errorDiv' >
                       {   success === "password"?"!!!Password Mismatched":null}
                        {  success === "email"? "!Email already exists":null}
                        </div>
                      </div>
                  }
                    <div className='signUp-form-btn'>             
                        <button type="submit" className="signUp-btn">Sign  Up</button>          
                        <button onClick={()=>setSignIn(true)} className='btn content-btn'><span >Already have an account Up ...? Login</span></button>
                    </div>
                </form>
          </div>
    </div>
  )
}
